import * as Yup from 'yup';

export const productionSchema = Yup.object({
  product_name: Yup.string().required(),
  category: Yup.string().required(),
  brand: Yup.string(),
  currency: Yup.string().required(),
  symbol: Yup.string().required(),
  price: Yup.string().required(),
  discount: Yup.string().required(),
  tex_price: Yup.string(),
  quantity: Yup.string().required(),
  tags: Yup.string(),
  description: Yup.string(),
  gallery: Yup.array().of(
    Yup.object().shape({
      pic_url: Yup.string(),
      pic_id: Yup.string(),
    })
  ),
});

export const productFormikForm = {
  product_name: '',
  category: '',
  brand: '',
  currency: 'NGN',
  symbol: '₦',
  price: '',
  discount: '',
  tex_price: '',
  quantity: '',
  tags: '',
  description: '',
  gallery: [
    {
      pic_url: '',
      pic_id: '',
    },
  ],
};
